let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("giQzE")).then(() => parcelRequire('1JmKN'));